import { render, staticRenderFns } from "./MenuDropdown.vue?vue&type=template&id=d634e9cc&scoped=true"
import script from "./MenuDropdown.vue?vue&type=script&lang=js"
export * from "./MenuDropdown.vue?vue&type=script&lang=js"
import style0 from "./MenuDropdown.vue?vue&type=style&index=0&id=d634e9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d634e9cc",
  null
  
)

export default component.exports